<div class="comment-container">
    <div class="text-right">
        <mat-icon (click)="onSubmit(false)" style="cursor: pointer;">close</mat-icon>
      </div>
    <div *ngIf="comments.length === 0" class="no-comments-msg">
        No comments available
      </div>
    <div *ngFor="let comment of comments" class="comment-card">
      <div class="top-line">
       <span class="picName"> {{ getUserName(comment.pic) }}</span>
        <span class="timestamp">{{ comment.timestamp  }}</span>
      </div>
      <div class="comment-text">{{ comment.comment }}</div>
    </div>
    <div (click)="downloadComments()" class="text-right download" >
      <mat-icon [matTooltip]="'Download Comments'">download</mat-icon>
      <!-- <span>Download Comments</span> -->
    </div>
    
  
    <button (click)="toggleForm()" class="btn btn-light hover-clear clear">Add Comment</button>
  
    <div *ngIf="showForm" class="add-form">
        <br>
   <div class="pic">
    <label>PIC:</label>
    <select [(ngModel)]="formData.newCommentPic" class="form-control picDropdown">
      <option *ngFor="let user of userList" [value]="user.value">{{ user.label }}</option>
    </select>
   </div>
  
      <textarea [(ngModel)]="formData.newCommentText" placeholder="Write your comment..." class="form-control"></textarea>
  
    <div class="text-center">
        <button  type="button" class="btn btn-light hover-clear clear"  (click)="onSubmit(true)">Submit</button>
    </div>
    </div>
  </div>
  